











import { Vue, Component, Prop } from "vue-property-decorator";
import CopyIcon from "../../../assets/svg/copy-icon.svg";

@Component({ components: { CopyIcon } })

export default class CopyLinkButton extends Vue {
    @Prop() copied: boolean;
}

